import { render, staticRenderFns } from "./ControlSettings.vue?vue&type=template&id=28f60514&scoped=true"
import script from "./ControlSettings.vue?vue&type=script&lang=js"
export * from "./ControlSettings.vue?vue&type=script&lang=js"
import style0 from "./control.css?vue&type=style&index=0&id=28f60514&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f60514",
  null
  
)

export default component.exports